import { InputFieldProps } from "./types";

export const CatCodeInput: React.FC<InputFieldProps> = ({ inputField, inputValue, onUpdate }) => {
	if (inputField.type !== "catCodes") {
		return <>non-enum types are currently not supported</>;
	}

	const selectedValues: string[] = Array.isArray(inputValue) ? inputValue : [];

	const toggleValue = (value: string) => {
		const newValues = selectedValues.includes(value) ? selectedValues.filter((v) => v !== value) : [...selectedValues, value];
		onUpdate?.(newValues.length > 0 ? newValues : undefined);
	};

	return (
		<div className="flex flex-row gap-2">
			{["1", "2", "3"].map((catCode) => {
				const isSelected = selectedValues.includes(catCode);
				return (
					<button
						key={catCode}
						onClick={() => toggleValue(catCode)}
						className={`w-16 h-8 rounded-md border font-medium transition-colors  items-center ${
							isSelected
								? "bg-blue-100 text-sm font-medium border-blue-200 text-blue-800"
								: "bg-white text-gray-700 border-gray-300 hover:border-blue-400"
						}`}
					>
						{catCode}
					</button>
				);
			})}
		</div>
	);
};
